import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";

import router from "./router";
import footerPage from "@/components/footerPage.vue"; 
import uploadImg from "@/components/uploadImg.vue";  
import paginationPage from "@/components/paginationPage.vue"; // 引入 Pagination 组件 

Vue.use(ElementUI);
Vue.component("footerPage", footerPage);
Vue.component("uploadImg", uploadImg);
// 注册全局组件
Vue.component("paginationPage", paginationPage);
// 使用VueRouter插件
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
